<template>
  <div class="">
    <nav>
      <!-- <span class="shij">
        <el-button @click="ern()" :class="adc == true ? 'xiansl' : 'yincl'"
          >24小时</el-button
        >
        <el-button @click="qi()" :class="ap == true ? 'xiansl' : 'yincl'"
          >近7天</el-button
        >
        <el-button @click="san()" :class="ad == true ? 'xiansl' : 'yincl'"
          >近30天</el-button
        >
      </span> -->
      <div class="shij">
        <div class="block">
          <!-- <span>发送时间：</span> -->
          <el-date-picker v-model="value1" type="datetimerange" range-separator="至" start-placeholder="开始日期"
            end-placeholder="结束日期" :picker-options="pickerOptions" @change="userTable" style="width: 50.0rem">
          </el-date-picker>
        </div>
      </div>
      <div class="shij">
        <!-- <span>部门: </span> -->
        <!-- <el-cascader v-model="departmentId" :options="departmentOptions" clearable :props="{ checkStrictly: true }"
          placeholder="请选择部门" @change="userTable"></el-cascader> -->
        <el-cascader style="width: 26.0rem" clearable v-model="departmentId" :options="departmentOptions"
          :props="{ value: 'id', label: 'name', children: 'children' }" @change="userTable"
          placeholder="请选择部门搜索"></el-cascader>
      </div>
      <div class="shij">
        <!-- <span>消息类型: </span> -->
        <el-select style="width: 26.0rem" clearable v-model="value" placeholder="请选择消息类型" @change="userTable">
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"
            @change="userTable">
          </el-option>
        </el-select>
      </div>
      <div class="shij" style="margin-right: .0rem
     ;display: flex ">
        <el-input clearable style="width: 26.0rem;margin-right: 2rem"
        placeholder="请搜索发送内容" prefix-icon="el-icon-search"
          v-model="input2" @change="userTable()">
        </el-input>
        <el-button style="background:#49B372 !important;" @click="userTable" type="primary" slot="append">查询</el-button>
      </div>
    </nav>
    <div>
      <el-table :data="tableData" border v-loading="tableLoading"  style="width: 100%; margin-top: 2.0rem">
        <el-table-column prop="from_name" label="发送方" style="width: 10%"></el-table-column>
        <el-table-column prop="tolist_name" label="接收方" style="width: 10%"></el-table-column>
        <el-table-column prop="department_name" label="部门" style="width: 10%">
          <template slot-scope="scope">
            <el-tag size="mini" style="margin: .2rem" v-for="t in scope.row.department_name_array" :key="t">{{ t }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="content" label="发送内容">
          <template slot-scope="scope">
            <div style="
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                " v-if="scope.row.msgtype == 'text'" :title="scope.row.content" class="chatting_records_jieshou">
              {{ scope.row.content }}
            </div>
            <div style="
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                " :title="
                  '祝福语：' +
                  scope.row.packet_wish +
                  '   金额：￥' +
                  scope.row.packet_totalamount +
                  '元'
                " v-if="scope.row.msgtype == 'redpacket'">
              祝福语：{{ scope.row.packet_wish }}&nbsp;&nbsp;&nbsp;金额：￥{{
                scope.row.packet_totalamount / 100
              }}元
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="msgtype" label="类型" style="width: 10%">
          <template slot-scope="scope">
            <div v-if="scope.row.msgtype == 'text'" class="leix">
              <img src="../../assets/cb7593481ac1e2e7d326dc52f00ca22.png" alt style="position: relative; top: .5rem" />
              <span>&nbsp;文本消息</span>
            </div>
            <div v-else-if="scope.row.msgtype == 'mixed'" class="leix">
              <img src="../../assets/51d0274e4c9895dce263a37a83c5b31.png" alt style="position: relative; top: .5rem" />
              <span>&nbsp;混合消息</span>
            </div>
            <div v-else-if="scope.row.msgtype == 'chatrecord'" class="leix">
              <img src="../../assets/4657daa2aa33a1a1f3114d6852bff46.png" alt style="position: relative; top: .5rem" />
              <span>&nbsp;会话记录</span>
            </div>
            <div v-else-if="scope.row.msgtype == 'todo'" class="leix">
              <img src="../../assets/3f5c16da9a2a30ba3d7192eb8c6640f.png" alt style="position: relative; top: .5rem" />
              <span>&nbsp;代办记录</span>
            </div>
            <div v-else-if="scope.row.msgtype == 'docmsg'" class="leix">
              <img src="../../assets/504c15917ed07a1f2b824d5fc6c44d5.png" alt style="position: relative; top: .5rem" />
              <span>&nbsp;在线文档</span>
            </div>
            <div v-else-if="scope.row.msgtype == 'meeting'" class="leix">
              <img src="../../assets/8a98fd465119872186d1d6b651a4481.png" alt style="position: relative; top: .5rem" />
              <span>&nbsp;会议邀请</span>
            </div>
            <div v-else-if="scope.row.msgtype == 'redpacket'" class="leix">
              <img src="../../assets/b927049ac34dd69992d6220fdb71201.png" alt style="position: relative; top: .5rem" />
              <span>&nbsp;红包记录</span>
            </div>
            <div v-else-if="scope.row.msgtype == 'image'" class="leix">
              <img src="../../assets/faa2e723d30c383e191028f57c75ea8.png" alt style="position: relative; top: .5rem" />
              <span>&nbsp;图片&#12288;&#12288;</span>
            </div>
            <div v-else-if="scope.row.msgtype == 'video'" class="leix">
              <img src="../../assets/b54ed789c0b61d2a7cf15e479044ffa.png" alt style="position: relative; top: .5rem" />
              <span>&nbsp;视频&#12288;&#12288;</span>
            </div>
            <div v-else-if="scope.row.msgtype == 'weapp'" class="leix">
              <img src="../../assets/ce18abd8225965e57ee4bc7f03529e7.png" alt style="position: relative; top: .5rem" />
              <span>&nbsp;小程序&#12288;</span>
            </div>
            <div v-else-if="scope.row.msgtype == 'location'" class="leix">
              <img src="../../assets/c4fe4ab0953c0f5fe4d42e9ce25d7c7.png" alt style="position: relative; top: .5rem" />
              <span>&nbsp;位置&#12288;&#12288;</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="msgtime" label="发送时间" style="width: 20%">
          <template slot-scope="scope">
            <div>{{ (scope.row.msgtime * 1000) | formatDate }}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="170" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" @click="
              bj(
                scope.row.content,
                scope.row.from,
                scope.row.tolist,
                scope.row.msgtime
              )
            " size="small">查看</el-button>
          </template>
        </el-table-column>
      </el-table>

    </div>
    <div class="paging">
      <pagination :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" :page-sizes="[10, 20, 50, 100]"
                  :auto-scroll="false" @pagination="userTable" />
    </div>
  </div>

</template>

<script>
import axios from "axios";
import qs from "qs";
import Pagination from "@/components/Pagination";
export default {
  name: "triggern",
  components: {
    Pagination,
  },
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      departmentId: [],
      departmentOptions: [],
      tableData: [],
      tooken: "",
      title: "",
      value1: [],
      options: [
        {
          value: "redpacket",
          label: "红包类型",
        },
        {
          value: "text",
          label: "消息类型",
        },
      ],
      value: "",

      input2: "",
      er: "",
      adc: false,
      ap: false,
      ad: false,
      yeshu: 1, //页数
      code: "",
      total: 0,
      listQuery: {
        page: 1,
        limit: 20,
      },
      tableLoading: true
    };
  },
  mounted() {
    // 页面刷新就请求到数据渲染到页面中
    // get请求页面的数据 http://192.168.0.149/api/Prive/getPriveList
    if (window.localStorage.getItem("storuser")) {
      let userinfo = JSON.parse(window.localStorage.getItem("storuser"));
      this.tooken = userinfo;
    }
    this.getDetaptment();
    this.userTable();
  },
  filters: {
    formatDate: function (value) {
      let date = new Date(value);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m;
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      return y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s;
    },
  },
  methods: {
    async getDetaptment() {
      const { data: res } = await this.axios({
        url: "/crm/DepartmentSet/getDepartmentList",
        method: "POST",
        data: qs.stringify({
          usertoken: this.tooken.usertoken,
          account_id: this.tooken.account_id,
          phone: this.tooken.phone,
        }),
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      });
      if (res.code == 1) {
        let data = res.data;
        this._formatArray(data);
        this.departmentOptions = data;
      }
    },
    _formatArray(array) {
      for (let index = 0; index < array.length; index++) {
        const element = array[index];
        element.label = element.name;
        element.value = element.id;
        if (element.children) {
          this._formatArray(element.children);
        }
      }
    },
    bj(e, g, m, o) {
      var content = o;
      var from = m;
      var tolist = g;
      var msgtime = e;
      sessionStorage.setItem("content", JSON.stringify(content));
      sessionStorage.setItem("from", JSON.stringify(from));
      sessionStorage.setItem("tolist", JSON.stringify(tolist));
      sessionStorage.setItem("msgtime", JSON.stringify(msgtime));
      this.$router.push("/register/user/saveContent?tolist="+tolist+'&msgtime='+msgtime+'&content='+content+'&from='+from);
    },
    userTable() {
      let a = "";
      let b = "";
      if (Array.isArray(this.value1)) {
        a = new Date(this.value1[0]).getTime();
        b = new Date(this.value1[1]).getTime();
        b = Number.parseInt((b * 1) / 1000);
        a = Number.parseInt((a * 1) / 1000);
      }
      this.axios
        .post(
          "/home/keyword/triggerRecord",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            phone: this.tooken.phone,
            page: this.listQuery.page,
            number_page: this.listQuery.limit,
            account_id: this.tooken.account_id,
            time: this.er,
            start_time: a,
            end_time: b,
            msgtype: this.value,
            content: this.input2,
            department_id: this.departmentId[this.departmentId.length - 1],
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          this.tableLoading = false;
          this.total = res.data.count;
          this.tableData = res.data.data;
        })
        .catch(function (err) { });
    },
    ern() {
      this.er = 1;
      this.adc = true;
      this.ap = false;
      this.ad = false;
      this.userTable();
    },
    qi() {
      this.er = 7;
      this.adc = false;
      this.ap = true;
      this.ad = false;
      this.userTable();
    },
    san() {
      this.er = 30;
      this.adc = false;
      this.ap = false;
      this.ad = true;
      this.userTable();
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 0) {
        return "warning-row";
      }
      return "success-row";
    },
  },
};
</script>
<style scoped>
.hello {
  width: 100%;
  height: 100%;
}

nav {
  width: 100%;
  display: flex;
}

.shij {
  display: inline-block;
  margin-right: 2.0rem;
}

.xiansl {
  color: #49B372 ;
}
::v-deep .el-button:hover{
  border-color: #E9F0EB ;
}

.yincl {
  background-color: #ffffff;
  color: black;
}

.aabou {
  height: 50.0rem;
  overflow: hidden;
  overflow-y: auto;
}
</style>
